export default defineAppConfig({
    ui: {
        colors: {
            primary: 'blue',
            neutral: 'gray',
        },
    },
    scheduling: {
        // Minimum time in minutes from now before a new appointment can start
        minAdvanceMinutes: 5,
        // Round start times up to the next multiple of this many minutes
        slotRoundingMinutes: 20,
    },
});
